export const imageState = {
  image: null,
  activelibrary: '',
  activepicturegallery: []
}
